import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import ReservaCita from './pages/ReservaCita';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

const Footer = styled.footer`
  background-color: #003366;
  color: white;
  padding: 20px;
  text-align: center;
  margin-top: auto;
  font-size: 0.9rem;
`;

const FooterLink = styled.a`
  color: white;
  text-decoration: none;
  margin: 0 10px;
  
  &:hover {
    text-decoration: underline;
  }
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <Routes>
          <Route path="/" element={<ReservaCita />} />
        </Routes>
        <Footer>
          <div>© {new Date().getFullYear()} Fisiofine. Todos los derechos reservados.</div>
          <div style={{ marginTop: '10px' }}>
            <FooterLink href="https://fisiofine.com">Sitio Web</FooterLink>
            <FooterLink href="tel:+34949222090">Teléfono: +34 949 22 20 90</FooterLink>
            <FooterLink href="mailto:info@fisiofine.com">Email: info@fisiofine.com</FooterLink>
          </div>
        </Footer>
      </AppContainer>
    </Router>
  );
}

export default App;
